export var marginAttributesList = {
  margin: true,
  marginTop: true,
  marginBottom: true,
  marginLeft: true,
  marginRight: true,
  marginX: true,
  marginY: true
};
export var marginAttributes = function marginAttributes(_ref) {
  var theme = _ref.theme,
      margin = _ref.margin,
      marginTop = _ref.marginTop,
      marginBottom = _ref.marginBottom,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight,
      marginX = _ref.marginX,
      marginY = _ref.marginY;
  var result = '';

  if (typeof margin !== 'undefined') {
    result += "margin: ".concat(theme.spacing(margin), ";");
  }

  if (typeof marginTop !== 'undefined') {
    result += "margin-top: ".concat(theme.spacing(marginTop), ";");
  }

  if (typeof marginBottom !== 'undefined') {
    result += "margin-bottom: ".concat(theme.spacing(marginBottom), ";");
  }

  if (typeof marginLeft !== 'undefined') {
    result += "margin-left: ".concat(theme.spacing(marginLeft), ";");
  }

  if (typeof marginRight !== 'undefined') {
    result += "margin-right: ".concat(theme.spacing(marginRight), ";");
  }

  if (typeof marginX !== 'undefined') {
    var value = theme.spacing(marginX);
    result += "margin-right: ".concat(value, "; margin-left: ").concat(value, ";");
  }

  if (typeof marginY !== 'undefined') {
    var _value = theme.spacing(marginY);

    result += "margin-top: ".concat(_value, "; margin-bottom: ").concat(_value, ";");
  }

  return result;
};